import { defineMessages } from 'react-intl';

export default defineMessages({
  errorTitle: 'Network connection error',
  errorDescription: 'Please wait a few seconds or try to reload the page manually.',
});
